const Currencies = [
  { code: "AFN", name: "Afghan Afghani", symbol: "؋", icon: "🇦🇫" },
  { code: "ALL", name: "Albanian Lek", symbol: "L", icon: "🇦🇱" },
  { code: "DZD", name: "Algerian Dinar", symbol: "دج", icon: "🇩🇿" },
  { code: "AOA", name: "Angolan Kwanza", symbol: "Kz", icon: "🇦🇴" },
  { code: "ARS", name: "Argentine Peso", symbol: "$", icon: "🇦🇷" },
  { code: "AMD", name: "Armenian Dram", symbol: "֏", icon: "🇦🇲" },
  { code: "AUD", name: "Australian Dollar", symbol: "A$", icon: "🇦🇺" },
  { code: "AZN", name: "Azerbaijani Manat", symbol: "₼", icon: "🇦🇿" },
  { code: "BSD", name: "Bahamian Dollar", symbol: "B$", icon: "🇧🇸" },
  { code: "BHD", name: "Bahraini Dinar", symbol: ".د.ب", icon: "🇧🇭" },
  { code: "BDT", name: "Bangladeshi Taka", symbol: "৳", icon: "🇧🇩" },
  { code: "BBD", name: "Barbadian Dollar", symbol: "Bds$", icon: "🇧🇧" },
  { code: "BYN", name: "Belarusian Ruble", symbol: "Br", icon: "🇧🇾" },
  { code: "BZD", name: "Belize Dollar", symbol: "BZ$", icon: "🇧🇿" },
  { code: "BMD", name: "Bermudian Dollar", symbol: "BD$", icon: "🇧🇲" },
  { code: "BTN", name: "Bhutanese Ngultrum", symbol: "Nu.", icon: "🇧🇹" },
  { code: "BOB", name: "Bolivian Boliviano", symbol: "Bs.", icon: "🇧🇴" },
  { code: "USD", name: "United States Dollar", symbol: "$", icon: "🇺🇸" },
  {
    code: "BAM",
    name: "Bosnia-Herzegovina Convertible Mark",
    symbol: "KM",
    icon: "🇧🇦",
  },
  { code: "BWP", name: "Botswana Pula", symbol: "P", icon: "🇧🇼" },
  { code: "BRL", name: "Brazilian Real", symbol: "R$", icon: "🇧🇷" },
  { code: "BGN", name: "Bulgarian Lev", symbol: "лв", icon: "🇧🇬" },
  { code: "BIF", name: "Burundian Franc", symbol: "FBu", icon: "🇧🇮" },
  { code: "KHR", name: "Cambodian Riel", symbol: "៛", icon: "🇰🇭" },
  { code: "CVE", name: "Cape Verdean Escudo", symbol: "Esc", icon: "🇨🇻" },
  {
    code: "XAF",
    name: "Central African CFA Franc",
    symbol: "FCFA",
    icon: "🇨🇫",
  },
  { code: "CLP", name: "Chilean Peso", symbol: "$", icon: "🇨🇱" },
  { code: "CNY", name: "Chinese Yuan", symbol: "¥", icon: "🇨🇳" },
  { code: "COP", name: "Colombian Peso", symbol: "$", icon: "🇨🇴" },
  { code: "KMF", name: "Comorian Franc", symbol: "CF", icon: "🇰🇲" },
  { code: "CDF", name: "Congolese Franc", symbol: "FC", icon: "🇨🇩" },
  { code: "CRC", name: "Costa Rican Colón", symbol: "₡", icon: "🇨🇷" },
  { code: "HRK", name: "Croatian Kuna", symbol: "kn", icon: "🇭🇷" },
  { code: "CUP", name: "Cuban Peso", symbol: "₱", icon: "🇨🇺" },
  { code: "CZK", name: "Czech Koruna", symbol: "Kč", icon: "🇨🇿" },
  { code: "DKK", name: "Danish Krone", symbol: "kr", icon: "🇩🇰" },
  { code: "DJF", name: "Djiboutian Franc", symbol: "Fdj", icon: "🇩🇯" },
  { code: "DOP", name: "Dominican Peso", symbol: "RD$", icon: "🇩🇴" },
  { code: "EGP", name: "Egyptian Pound", symbol: "£", icon: "🇪🇬" },
  { code: "ETB", name: "Ethiopian Birr", symbol: "Br", icon: "🇪🇹" },
  { code: "FJD", name: "Fijian Dollar", symbol: "FJ$", icon: "🇫🇯" },
  { code: "GMD", name: "Gambian Dalasi", symbol: "D", icon: "🇬🇲" },
  { code: "GEL", name: "Georgian Lari", symbol: "₾", icon: "🇬🇪" },
  { code: "GHS", name: "Ghanaian Cedi", symbol: "GH₵", icon: "🇬🇭" },
  { code: "GTQ", name: "Guatemalan Quetzal", symbol: "Q", icon: "🇬🇹" },
  { code: "GNF", name: "Guinean Franc", symbol: "FG", icon: "🇬🇳" },
  { code: "GYD", name: "Guyanese Dollar", symbol: "G$", icon: "🇬🇾" },
  { code: "HTG", name: "Haitian Gourde", symbol: "G", icon: "🇭🇹" },
  { code: "HNL", name: "Honduran Lempira", symbol: "L", icon: "🇭🇳" },
  { code: "HUF", name: "Hungarian Forint", symbol: "Ft", icon: "🇭🇺" },
  { code: "ISK", name: "Icelandic Króna", symbol: "kr", icon: "🇮🇸" },
  { code: "IDR", name: "Indonesian Rupiah", symbol: "Rp", icon: "🇮🇩" },
  { code: "IRR", name: "Iranian Rial", symbol: "﷼", icon: "🇮🇷" },
  { code: "IQD", name: "Iraqi Dinar", symbol: "ع.د", icon: "🇮🇶" },
  { code: "ILS", name: "Israeli New Shekel", symbol: "₪", icon: "🇮🇱" },
  { code: "JMD", name: "Jamaican Dollar", symbol: "J$", icon: "🇯🇲" },
  { code: "JOD", name: "Jordanian Dinar", symbol: "د.ا", icon: "🇯🇴" },
  { code: "KZT", name: "Kazakhstani Tenge", symbol: "₸", icon: "🇰🇿" },
  { code: "KES", name: "Kenyan Shilling", symbol: "KSh", icon: "🇰🇪" },
  { code: "KWD", name: "Kuwaiti Dinar", symbol: "د.ك", icon: "🇰🇼" },
  { code: "LAK", name: "Lao Kip", symbol: "₭", icon: "🇱🇦" },
  { code: "LBP", name: "Lebanese Pound", symbol: "ل.ل", icon: "🇱🇧" },
  { code: "LSL", name: "Lesotho Loti", symbol: "L", icon: "🇱🇸" },
  { code: "LYD", name: "Libyan Dinar", symbol: "ل.د", icon: "🇱🇾" },
  { code: "MOP", name: "Macanese Pataca", symbol: "MOP$", icon: "🇲🇴" },
  { code: "MWK", name: "Malawian Kwacha", symbol: "MK", icon: "🇲🇼" },
  { code: "MYR", name: "Malaysian Ringgit", symbol: "RM", icon: "🇲🇾" },
  { code: "MVR", name: "Maldivian Rufiyaa", symbol: "Rf", icon: "🇲🇻" },
  { code: "MRU", name: "Mauritanian Ouguiya", symbol: "UM", icon: "🇲🇷" },
  { code: "MUR", name: "Mauritian Rupee", symbol: "₨", icon: "🇲🇺" },
  { code: "MXN", name: "Mexican Peso", symbol: "$", icon: "🇲🇽" },
  { code: "MDL", name: "Moldovan Leu", symbol: "L", icon: "🇲🇩" },
  { code: "MAD", name: "Moroccan Dirham", symbol: "د.م.", icon: "🇲🇦" },
  { code: "MZN", name: "Mozambican Metical", symbol: "MT", icon: "🇲🇿" },
  { code: "NAD", name: "Namibian Dollar", symbol: "N$", icon: "🇳🇦" },
  { code: "NPR", name: "Nepalese Rupee", symbol: "Rs.", icon: "🇳🇵" },
  {
    code: "ANG",
    name: "Netherlands Antillean Guilder",
    symbol: "ƒ",
    icon: "🇳🇱",
  },
  { code: "NZD", name: "New Zealand Dollar", symbol: "NZ$", icon: "🇳🇿" },
  { code: "NIO", name: "Nicaraguan Córdoba", symbol: "C$", icon: "🇳🇮" },
  { code: "NGN", name: "Nigerian Naira", symbol: "₦", icon: "🇳🇬" },
  { code: "NOK", name: "Norwegian Krone", symbol: "kr", icon: "🇳🇴" },
  { code: "OMR", name: "Omani Rial", symbol: "ر.ع.", icon: "🇴🇲" },
  { code: "PKR", name: "Pakistani Rupee", symbol: "₨", icon: "🇵🇰" },
  { code: "PAB", name: "Panamanian Balboa", symbol: "B/.", icon: "🇵🇦" },
  { code: "PGK", name: "Papua New Guinean Kina", symbol: "K", icon: "🇵🇬" },
  { code: "PYG", name: "Paraguayan Guaraní", symbol: "₲", icon: "🇵🇾" },
  { code: "PEN", name: "Peruvian Sol", symbol: "S/.", icon: "🇵🇪" },
  { code: "PHP", name: "Philippine Peso", symbol: "₱", icon: "🇵🇭" },
  { code: "PLN", name: "Polish Zloty", symbol: "zł", icon: "🇵🇱" },
  { code: "QAR", name: "Qatari Riyal", symbol: "ر.ق", icon: "🇶🇦" },
  { code: "RON", name: "Romanian Leu", symbol: "lei", icon: "🇷🇴" },
  { code: "RWF", name: "Rwandan Franc", symbol: "RF", icon: "🇷🇼" },
  { code: "SHP", name: "Saint Helena Pound", symbol: "£", icon: "🇸🇭" },
  { code: "WST", name: "Samoan Tala", symbol: "WS$", icon: "🇼🇸" },
  {
    code: "STD",
    name: "São Tomé and Príncipe Dobra",
    symbol: "Db",
    icon: "🇸🇹",
  },
  { code: "SAR", name: "Saudi Riyal", symbol: "﷼", icon: "🇸🇦" },
  { code: "RSD", name: "Serbian Dinar", symbol: "дин.", icon: "🇷🇸" },
  { code: "SCR", name: "Seychellois Rupee", symbol: "₨", icon: "🇸🇨" },
  { code: "SLL", name: "Sierra Leonean Leone", symbol: "Le", icon: "🇸🇱" },
  { code: "SGD", name: "Singapore Dollar", symbol: "S$", icon: "🇸🇬" },
  { code: "SBD", name: "Solomon Islands Dollar", symbol: "SI$", icon: "🇸🇧" },
  { code: "SOS", name: "Somali Shilling", symbol: "Sh", icon: "🇸🇴" },
  { code: "ZAR", name: "South African Rand", symbol: "R", icon: "🇿🇦" },
  { code: "KRW", name: "South Korean Won", symbol: "₩", icon: "🇰🇷" },
  { code: "SSP", name: "South Sudanese Pound", symbol: "£", icon: "🇸🇸" },
  { code: "LKR", name: "Sri Lankan Rupee", symbol: "₨", icon: "🇱🇰" },
  { code: "SDG", name: "Sudanese Pound", symbol: "ج.س.", icon: "🇸🇩" },
  { code: "SRD", name: "Surinamese Dollar", symbol: "$", icon: "🇸🇷" },
  { code: "SZL", name: "Swazi Lilangeni", symbol: "E", icon: "🇸🇿" },
  { code: "SEK", name: "Swedish Krona", symbol: "kr", icon: "🇸🇪" },
  { code: "CHF", name: "Swiss Franc", symbol: "CHF", icon: "🇨🇭" },
  { code: "SYP", name: "Syrian Pound", symbol: "£S", icon: "🇸🇾" },
  { code: "TWD", name: "Taiwan Dollar", symbol: "NT$", icon: "🇹🇼" },
  { code: "TJS", name: "Tajikistani Somoni", symbol: "ЅM", icon: "🇹🇯" },
  { code: "TZS", name: "Tanzanian Shilling", symbol: "TSh", icon: "🇹🇿" },
  { code: "THB", name: "Thai Baht", symbol: "฿", icon: "🇹🇭" },
  { code: "TOP", name: "Tongan Paʻanga", symbol: "T$", icon: "🇹🇴" },
  {
    code: "TTD",
    name: "Trinidad and Tobago Dollar",
    symbol: "TT$",
    icon: "🇹🇹",
  },
  { code: "TND", name: "Tunisian Dinar", symbol: "د.ت", icon: "🇹🇳" },
  { code: "TRY", name: "Turkish Lira", symbol: "₺", icon: "🇹🇷" },
  { code: "TMT", name: "Turkmenistani Manat", symbol: "T", icon: "🇹🇲" },
  { code: "UGX", name: "Ugandan Shilling", symbol: "USh", icon: "🇺🇬" },
  { code: "UAH", name: "Ukrainian Hryvnia", symbol: "₴", icon: "🇺🇦" },
  {
    code: "AED",
    name: "United Arab Emirates Dirham",
    symbol: "د.إ",
    icon: "🇦🇪",
  },
  { code: "UYU", name: "Uruguayan Peso", symbol: "$U", icon: "🇺🇾" },
  { code: "UZS", name: "Uzbekistani Som", symbol: "лв", icon: "🇺🇿" },
  { code: "VUV", name: "Vanuatu Vatu", symbol: "VT", icon: "🇻🇺" },
  { code: "VES", name: "Venezuelan Bolívar", symbol: "Bs.", icon: "🇻🇪" },
  { code: "VND", name: "Vietnamese Dong", symbol: "₫", icon: "🇻🇳" },
  { code: "YER", name: "Yemeni Rial", symbol: "﷼", icon: "🇾🇪" },
  { code: "ZMW", name: "Zambian Kwacha", symbol: "ZK", icon: "🇿🇲" },
  { code: "ZWL", name: "Zimbabwean Dollar", symbol: "Z$", icon: "🇿🇼" },
];

export default Currencies;
